module.exports = __webpack_public_path__ + "img/password.f3151c38.svg";